<template>
  <svg viewBox="0 0 30 30" class="inline-svg-icon pointer-cursor">
    <line x1="7.5" y1="17.1524" x2="12.8475" y2="22.5" stroke="#0a0" stroke-width="3" stroke-linecap="round" />
    <line x1="12.8475" y1="22.5" x2="21.5" y2="8.5" stroke="#0a0" stroke-width="3" stroke-linecap="round" />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CheckmarkIcon",
});
</script>

<style scoped>
svg.shadow {
  filter: drop-shadow(3px 5px 2px rgba(0, 0, 0, 0.42));
}
</style>
